export default __webpack_public_path__ + "static/media/warehouseWorker.ed996ea8.svg";